import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import backOff from './back-off';

function withRetry(func) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var retryOptions = _objectSpread({
    haltOnStatus: []
  }, opts);

  var backOffOpts = {
    attemptCount: 1
  }; // Assists with mocking API calls with nock in tests

  if (process && process.env && process.env.NODE_ENV === 'test') {
    backOffOpts.delay = 5;
    backOffOpts.maxDelay = 500;
  }

  var next = backOff.async(_objectSpread(_objectSpread({}, backOffOpts), opts));
  return function (options, callback) {
    var makeRequest = function makeRequest() {
      func(options, function (status, response) {
        if (retryOptions.haltOnStatus.includes(status)) {
          callback(status, response);
          return;
        }

        if (status >= 200 && status < 300) {
          callback(status, response);
        } else if (!next(function () {
          return makeRequest();
        })) {
          callback(status, response);
        }
      });
    };

    makeRequest();
  };
}

export default withRetry;
//# sourceMappingURL=with-retry.js.map